module.exports = __webpack_public_path__ + "media/scholarship_winners/josh-b-8d07c2ac.png";